import type { EmailTemplateAddEditFormProps } from '../types/components'
import { EmailTemplateNotesHistory } from './EmailTemplateNotesHistory'
import { EmailTemplateContentSection } from './add-edit-form/EmailTemplateContentSection'
import { EmailTemplateFormActions } from './add-edit-form/EmailTemplateFormActions'
import { EmailTemplateInfoSection } from './add-edit-form/EmailTemplateInfoSection'
import { EmailTemplateMetadataSection } from './add-edit-form/EmailTemplateMetadataSection'
import { EmailTemplateRecipientsSection } from './add-edit-form/EmailTemplateRecipientsSection'
import { EmailTemplateStatusSection } from './add-edit-form/EmailTemplateStatusSection'
import { EmailTemplateWorkflowBlocksSection } from './add-edit-form/EmailTemplateWorkflowBlocksSection'
import { EmailTemplateWorkflowSection } from './add-edit-form/EmailTemplateWorkflowSection'

export function EmailTemplateAddEditForm({ page }: EmailTemplateAddEditFormProps) {
  const { handleSubmit, onFormValid, isEdit, templateDetail } = page

  return (
    <form
      onSubmit={handleSubmit(onFormValid)}
      className="form_inline w-full min-w-0 space-y-5 px-4 py-6 sm:px-6"
      noValidate
    >
      <EmailTemplateStatusSection page={page} />
      <EmailTemplateInfoSection page={page} />
      <EmailTemplateWorkflowSection page={page} />
      <EmailTemplateMetadataSection page={page} />
      <EmailTemplateRecipientsSection page={page} />
      <EmailTemplateContentSection page={page} />
      <EmailTemplateWorkflowBlocksSection page={page} />
      <EmailTemplateFormActions page={page} />

      {isEdit && templateDetail?.notes && templateDetail.notes.length > 0 ? (
        <EmailTemplateNotesHistory notes={templateDetail.notes} />
      ) : null}
    </form>
  )
}
